import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function NotificationBell() {
    const [count, setCount] = useState(0);

    const load = async () => {
        try {
            const { data } = await api.get("/notifications/unread-count");
            setCount(data.count || 0);
        } catch {}
    };

    useEffect(() => {
        load();
        const t = setInterval(load, 30000);
        return () => clearInterval(t);
    }, []);

    return (
        <Link to="/notifications"
            className="relative inline-flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-komma-navy/5 transition-colors"
            data-testid="notif-bell">
            <Bell size={18} className="text-komma-navy" />
            {count > 0 && (
                <span
                    className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-komma-gold text-komma-navy text-[10px] font-bold flex items-center justify-center"
                    data-testid="notif-bell-count">
                    {count > 99 ? "99+" : count}
                </span>
            )}
        </Link>
    );
}
